import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { PiEyeClosed } from "react-icons/pi";
import { IoMdEye } from "react-icons/io";
import useUserStore from "store/user";
import useAlertStore from "store/alert";
import useModalStore from "store/modal";
import { useCheckMemApi } from "./service";
import ManagerDetail from "./manager/detail";
import { ManagerDetailProvider } from "./manager/context";

export default function ModalInner() {
  const { t } = useTranslation();
  const user = useUserStore((state) => state.user);

  const [isOpen, setIsOpen] = useState(false); // 비밀번호 확인
  const [lgnPwd, setLgnPwd] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const txtRef = useRef<HTMLParagraphElement | null>(null);

  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const onSetModal = useModalStore((state) => state.onSetModal);

  const { mutate } = useCheckMemApi({ setOpenModal });

  const onManagerDetail = () => {
    onSetAlert({
      isOpen: true,
      inner: "회원정보를 조회하시겠습니까?",
      cnclBtn: true,
      chkBnt: true,
      onSetConfirm: () => {
        // 회원 확인
        if (!user?.emlId) return;
        if (user?.emlId) {
          mutate({ emlId: user?.emlId, lgnPwd });
        }
      },
    });
  };

  // 회원확인 성공 후 매니저정보 조회
  useEffect(() => {
    if (openModal) {
      onSetModal({
        title: "매니저 상세",
        isOpen: true,
        styles: "w-full overflow-visible",
        inner: (
          <ManagerDetailProvider>
            <ManagerDetail />,
          </ManagerDetailProvider>
        ),
      });
    }
  }, [openModal]);

  useLayoutEffect(() => {
    if (txtRef.current) {
      txtRef.current.innerHTML = t("md_check_pwd_txt_1");
    }
  }, []);

  return (
    <>
      <form id="check-pwd" className="text-center">
        <p className="text-red-400 font-bold text-xs" ref={txtRef} />
        <ul className="flex col gap-2 py-5">
          <li className="flex justify-start">
            <label htmlFor="">{t("lbl_id_cmm")}</label>
            <input
              type="text"
              name="emlId"
              defaultValue={user?.emlId} // emlId
              className="w-full h-[28px]"
              data-type="R"
              readOnly
            />
          </li>
          <li className="flex justify-start relative">
            <label htmlFor="">{t("lbl_pw_cmm")}</label>
            <input
              type={isOpen ? "text" : "password"}
              name="lgnPwd"
              className="w-full h-[28px]"
              autoComplete="off"
              value={lgnPwd}
              onChange={(e) => {
                setLgnPwd(e.currentTarget.value);
              }}
              required
            />
            <span
              className="absolute right-2 top-2"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              {!isOpen && <PiEyeClosed size={16} />}
              {isOpen && <IoMdEye size={16} />}
            </span>
          </li>
        </ul>
      </form>
      <div className="flex justify-center gap-2">
        <button
          className={!!lgnPwd ? "btn bg-red-400" : "btn bg-gray-400"}
          disabled={!lgnPwd}
          onClick={onManagerDetail}
        >
          확인
        </button>
      </div>
    </>
  );
}
